import { alpha, Theme } from '@mui/material';

export default {
    container: {
        backgroundColor: 'background.default',
    },
    section: {
        '&:has(.element-data-section__rows-holder:empty)': {
            display: 'none',
        },
    },
    sectionHeader: {
        wordWrap: 'break-word',
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
        px: 1.5,
        '.element-data-container--size-small &': {
            pt: '3px',
            pb: '2px',
        },
        '.element-data-container--size-medium &': {
            pt: '5px',
            pb: '4px',
        },
        '.element-data-container--mod-radius-section &': {
            borderRadius: '3px',
        },
        '.element-data-container--headers-hide &.element-data-section__header--adjustable': {
            display: 'none',
        },
    },
    sectionRowsHolder: {
        '&:empty': {
            backgroundColor: 'red',
        },
    },

    row: {
        /*'&:first-of-type': {
            borderTopWidth: 0,
        },*/
        borderTop: '1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),

        '.element-data-container--size-small &': {
            py: '5px',
        },
        '.element-data-container--size-medium &': {
            py: '6px',
        },
        px: 1.5,

        '& a': {
            textDecoration: 'underline',
            '&:hover': {
                textDecoration: 'none',
            },
        },
    },
    labelHolder: {
        mr: 1,
        flexShrink: 0,

        '.element-data-container--size-small &': {
            width: '124px',
        },
        '.element-data-container--size-medium &': {
            width: '148px',
        },
        '&.element-data-row-label--only-icon': {
            width: 'auto',
            mr: 0,
        },
    },

    labelIcon: {
        flexShrink: 0,
        width: '16px',
        height: (theme: Theme) => theme.size.lineHeight * (theme.typography.body1.fontSize as number),
        mr: 1,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',

        '.svg-icon-mi': {
            fontSize: '16px',
        },
        '.svg-inline--fa': {
            fontSize: '14px',
        },
    },
    labelText: {
        flexGrow: 1,
        overflow: 'hidden',
        wordWrap: 'break-word',
    },

    value: {
        flexGrow: 1,
        overflow: 'hidden',
        wordWrap: 'break-word',
    },

    previewColor: {
        width: '16px',
        height: '16px',
        ml: 1,
        mr: '-6px',
        flexShrink: 0,
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.16)}`,
        '.design-variant--secondary &': {
            ml: '6px',
            mr: '-2px',
            borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.24),
            borderRadius: '1px',
        },
    },

    descriptionContainer: {
        overflow: 'hidden',
    },
    descriptionHolder: {
        overflow: 'hidden',
        wordWrap: 'break-word',
    },
    descriptionExpandControl: {
        lineHeight: 1,
        mt: 1,
        textAlign: 'center',
        color: 'primary.main',
        '&:hover': { opacity: 0.75, cursor: 'pointer' },
    },

    collapseExpandItem: {
        '&.collapse-expand-item--state-expand': {
            '.collapse-expand-item__header': {
                color: 'primary.main',
                fontWeight: 600,
                '&:hover': {
                    opacity: 0.75,
                    cursor: 'pointer',
                },
            },
        },
        '&.collapse-expand-item--state-collapse': {
            '.collapse-expand-item__header': {
                '.summary--default &': {
                    color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
                },
                '&:hover': {
                    opacity: 0.75,
                    cursor: 'pointer',
                    color: 'primary.main',
                },
            },
            '& .collapse-expand-item__children': {
                overflow: 'hidden',
                height: 0,
            },
        },
    },
};
